export default {
  computed: {
    emptyPrice() {
      return `(${this.$t('repairEmptyPrice')})`
    },
  },
  methods: {
    getPrice(item) {
      return `: ${item.note || ''} ${item.price} ${item.currency}`
    },
    getPath(slug = '') {
      return `${this.lang ? `/${this.lang}` : ''}/service/${slug}`
    },
  },
}
